/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-27 16:30:40
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-27 18:56:13
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\BasePriceSelect\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect, useMemo } from 'react';
import { Button, Modal, Input, Radio, Form, Select } from '@bedrock/components';
import { ProTablePlus } from '@bedrock/eed-react';
import { Close, Edit, ChevronRight, Clock } from '@bedrock/icons-react';
import { useMemoizedFn } from 'ahooks';
import { CurrencyType } from '#components/SForm';
import { FormItemRow } from '#components/SForm/createFormItemRow';
import styles from './index.less';

import withFunctionCall from '#utils/withFunctionCall';
import {
  tableColumnWidthToRem,
  multiFieldSort,
  type SortConfigItem,
  localPx2rem,
} from '#utils';
import { type BasePriceConfigDto } from '#services/api';
import { mockBasePrices } from './mock';
import { get } from 'lodash';
import classNames from 'classnames/bind';
import CustomPriceModal from './CustomPriceModal';

const cx = classNames.bind(styles);
type BasePrice = BasePriceConfigDto;

type BasePriceModalProps = {
  /** 查询基准价列表的请求函数，返回 Promise<{ data: BasePriceConfigDto[] }> */
  queryRequest: () => Promise<{ data: BasePriceConfigDto[] }>;
  title: string;
  value: BasePrice;
  onChange: (value: BasePrice) => void;
  view: boolean;
  viewCurrencyType: string;
  onClose?: () => void;
};

/**
 * 判断两个基准价配置是否相等
 * @description 通过比较关键字段来判断两个基准价对象是否为同一个基准价
 * @param a - 基准价对象A
 * @param b - 基准价对象B
 * @returns 如果所有关键字段都相等则返回true，否则返回false
 */
function isEqualBasePrice(
  a: BasePriceConfigDto,
  b: BasePriceConfigDto
): boolean {
  return [
    'source_name', // 来源名称（大类）
    'source_type', // 来源类型
    'base_price_name', // 基准价名称（小类）
    'base_price', // 基准价金额
    'base_price_currency', // 基准价货币类型
  ].every((key) => get(a, key) == get(b, key));
}

/**
 * 基准价选择弹窗组件
 * @description 用于展示和选择基准价的弹窗，支持筛选、排序、自定义价格等功能
 */
const BasePriceModal = (props: BasePriceModalProps) => {
  const {
    queryRequest, // 查询基准价列表的请求函数
    title = '编辑基准价',
    value, // 当前选中的基准价
    onChange, // 基准价变更回调
    view, // 是否为查看模式
    viewCurrencyType, // 目标货币类型
    onClose,
    ...rest
  } = props;

  // 基准价列表数据
  const [data, setData] = useState<BasePriceConfigDto[]>([]);
  const [loading, setLoading] = useState(false);
  // 筛选条件参数（用于表格筛选）
  const [filterParams, setFilterParams] = useState<any>({});

  // 排序配置（支持多字段排序）
  const [sortConfig, setSortConfig] = useState<SortConfigItem[]>([]);

  // 当前选中的基准价数据
  const [selectedData, setSelectedData] = useState<BasePriceConfigDto | null>(
    value
  );

  /**
   * 生成来源名称（大类）的下拉选项
   * @description 从基准价列表中提取唯一的source_name作为筛选选项
   */
  const sourceNameOptions = useMemo(() => {
    // 根据 source_name 去重
    const seen = new Set();
    return data.reduce((acc, item) => {
      if (item.source_name && !seen.has(item.source_name)) {
        seen.add(item.source_name);
        acc.push({ name: item.source_name, value: item.source_name });
      }
      return acc;
    }, []);
  }, [data]);

  /**
   * 表格列配置
   * @description 定义基准价表格的列结构，包括单选、大类、小类、参考价等列
   */
  const columns = useMemo(() => {
    return [
      {
        // 单选列：用于选择基准价
        title: '',
        dataIndex: 'select',
        align: 'left',
        width: 40,
        show: !view, // 查看模式下隐藏单选框
        render: (text, record) => {
          return (
            <Radio
              checked={!!isEqualBasePrice(selectedData, record)}
              disabled={!!record.disable}
              onClick={(e) => {
                if (record.disable) {
                  return;
                }
                e.stopPropagation();
                setSelectedData(record);
              }}
            />
          );
        },
      },
      {
        title: '大类',
        dataIndex: 'source_name',
        align: 'left',
        width: 280,
        sortable: true,
        render: (text) => (
          <div>
            <span className="font-bold">{text || '--'}</span>
          </div>
        ),
        searchRender: {
          type: 'select_multiple',
          useDefault: true,
          showCondition: false,
          filterComponentProps: {
            options: sourceNameOptions,
            showSearch: true,
          },
        },
      },
      {
        title: '小类',
        dataIndex: 'base_price_name',
        align: 'left',
        width: 280,
        sortable: true,
        render: (text, record) => (
          <div>
            {text || '--'}
            {record.cooperate_time_list?.length > 0 && (
              <Button
                type="text"
                icon={<Clock />}
                size="small"
                className="ml-1"
                onClick={(e) => {
                  e.stopPropagation();
                  openCooperateTimeModal.show({
                    listData: record.cooperate_time_list,
                  });
                }}
              >
                合作时间
              </Button>
            )}
          </div>
        ),
        searchRender: {
          type: 'text',
          showCondition: false,
          useDefault: true,
          filterComponentProps: {
            style: {
              width: localPx2rem(280),
            },
          },
        },
      },
      {
        title: '参考价',
        dataIndex: 'base_price',
        align: 'right',
        width: 200,
        sortable: true,
        render: (text, record) => (
          <CurrencyType
            view={true}
            viewCurrencyType={viewCurrencyType as any}
            value={{ value: text, currency: record.base_price_currency }}
            currencyColor="black"
          />
        ),
      },
    ]
      .map(tableColumnWidthToRem)
      .filter((column: any) => column?.show !== false);
  }, [view, selectedData, sourceNameOptions]);

  const initBasePriceData = useMemoizedFn(async () => {
    let data = [];
    try {
      setLoading(true);
      const res = await queryRequest?.();
      data = res?.data ?? [];
    } finally {
      setLoading(false);
    }

    // 如果已选中的是非自定义价格，则将其添加到列表顶部，确保用户能看到当前选中项
    if (
      selectedData?.source_type &&
      selectedData.source_type !== 'CUSTOM_PRICE'
    ) {
      // 如果当前选中的数据不在列表中，则将其添加到列表顶部
      if (!data.some((item: any) => isEqualBasePrice(item, selectedData))) {
        data.unshift(selectedData);
      }
    }
    setData(data);
  });

  /**
   * 初始化加载基准价数据
   * @description 在组件挂载时获取基准价列表，如果当前已选中非自定义价格，则将其添加到列表顶部
   */
  useEffect(() => {
    initBasePriceData();
  }, []);

  /**
   * 确认选择基准价
   * @description 将选中的基准价通过onChange回调传递给父组件，并关闭弹窗
   */
  const handleOk = useMemoizedFn(() => {
    if (selectedData) {
      onChange?.(selectedData);
      onClose?.();
    }
  });

  /**
   * 计算表格展示数据
   * @description 对原始数据进行筛选和排序处理
   * 处理逻辑：
   * 1. 为每行数据添加rowIndex索引
   * 2. 根据filterParams进行筛选（选中的数据始终显示）
   * 3. 根据sortConfig进行多字段排序
   */
  const showData = useMemo(() => {
    let result = data
      .map((item, index) => {
        return {
          ...item,
          rowIndex: index,
        };
      })
      .filter((item) => {
        // 如果是当前选中的数据，则始终显示（不受筛选影响）
        if (isEqualBasePrice(selectedData, item)) {
          return true;
        }
        // 根据filterParams过滤数据
        return Object.entries(filterParams).every(([key, value]) => {
          // 空值或空数组不进行过滤
          if (
            value === undefined ||
            value === null ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
          ) {
            return true;
          }
          // 如果筛选值是数组，则判断item[key]是否匹配数组中的任意一项（多选筛选）
          if (Array.isArray(value)) {
            return value.some((itemValue) => get(item, key) === itemValue);
          }
          // 如果筛选值是字符串，则进行模糊匹配
          if (typeof value === 'string') {
            return get(item, key)?.includes?.(value);
          }
          // 其他类型进行精确匹配
          return get(item, key) === value;
        });
      });
    /**
     * 根据多字段级别排序数据
     * 优先级字段：source_name（大类）, base_price_name（小类）, base_price（参考价）
     * 可根据外部传入的sortConfig控制升降序，多字段联合排序，sortConfig为[{key, sortOrder}]
     * 注意：未指定排序时不变，未比较的字段不排序
     */
    if (sortConfig.length > 0) {
      const sortKeyLevel = ['source_name', 'base_price_name', 'base_price'];
      result = multiFieldSort(result, sortConfig, sortKeyLevel);
    }

    return result;
  }, [data, sortConfig, filterParams]);

  const onChangeTemp = useMemoizedFn((value: BasePrice) => {
    onChange?.(value);
    onClose?.();
  });

  /**
   * 打开自定义价格弹窗
   * @description 关闭当前基准价弹窗并打开自定义价格弹窗
   */
  const openCustomPriceModalTemp = useMemoizedFn(() => {
    openCustomPriceModal.show({
      value: value,
      onChange: onChangeTemp,
    });
  });

  /**
   * 首次打开时的特殊处理
   * @description 如果当前已选中的是自定义价格，则直接跳转到自定义价格弹窗
   */
  useEffect(() => {
    if (value?.source_type === 'CUSTOM_PRICE' && !view) {
      openCustomPriceModalTemp();
    }
  }, []);

  return (
    <Modal
      title={title || '基准价'}
      width={880}
      height={600}
      {...rest}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      renderFooter={(cancelButton, rejectButton, okButton) => {
        if (view) {
          return <></>;
        }
        return (
          <div className="flex justify-end items-center gap-1">
            {cancelButton}
            <Button
              type="checked"
              onClick={openCustomPriceModalTemp}
              icon={<Edit />}
            >
              自定义价格
            </Button>
            {okButton}
          </div>
        );
      }}
    >
      <div className="pb-1" style={{ minHeight: 350 }}>
        <ProTablePlus
          columns={columns}
          data={showData}
          isShowLoading={loading}
          allowMultiSort
          rowKey="rowIndex"
          onSortChange={(dataIndex, sortOrder, newSortedColumns) => {
            setSortConfig(newSortedColumns);
          }}
          scroll={{ x: 'max-content', y: 350 }}
          toolbar={{
            filterSetting: {
              onChange: (filters, state) => {
                const filterParamsTemp = filters.reduce(
                  (acc: any, item: any) => {
                    acc[item.value] = item.filterValue;
                    return acc;
                  },
                  {} as any
                );
                setFilterParams((filterParams) => ({
                  ...filterParams,
                  ...filterParamsTemp,
                }));
              },
              onReset: () => {
                setFilterParams({});
              },
              disableAddButton: true,
            },
          }}
          border
          size="medium"
        />
      </div>
    </Modal>
  );
};

/**
 * 合作时间弹窗组件
 * @description 展示该合作账号的历史合作记录，包括合作时间、单号、金额等信息
 */
const CooperateTimeModal = (props: {
  listData: any[];
  onClose?: () => void;
}) => {
  const { listData, onClose, ...rest } = props;
  // 合作记录列表数据
  const [data, setData] = useState<any[]>(listData);

  const columns = useMemo(() => {
    return [
      {
        title: '合作时间',
        dataIndex: 'cooperate_time',
        align: 'left',
        width: 200,
        sortable: true,
        render: (text) => (
          <div>
            <span className="font-bold">{text || '--'}</span>
          </div>
        ),
      },
      // {
      //   title: '单号',
      //   dataIndex: 'order_no',
      //   align: 'left',
      //   width: 200,
      //   sortable: true,
      //   render: (text) => (<Button type="link" size="small" onClick={() => {
      //     window.open(`/#/marketWorkbench/marketGroup/projectDetailSingle/${text}`, '_blank')
      //   }}>{text || '--'}</Button>),
      // },
      // {
      //   title: '金额',
      //   dataIndex: 'amount',
      //   align: 'right',
      //   width: 200,
      //   sortable: true,
      //   render: (text) => (<CurrencyType view={true} value={{ value: text, currency: 'rmb' }} currencyColor="black" />),
      // }
    ];
  }, []);

  return (
    <Modal
      title="合作时间"
      width={640}
      height={640}
      renderFooter={() => <></>}
      onClose={onClose}
      {...rest}
    >
      <div>
        <ProTablePlus
          columns={columns}
          data={data}
          allowMultiSort
          rowKey="rowIndex"
        />
      </div>
    </Modal>
  );
};

// 使用HOC包装各个弹窗组件，使其支持函数式调用
const openCustomPriceModal = withFunctionCall(CustomPriceModal);
const openCooperateTimeModal = withFunctionCall(CooperateTimeModal);
const openBasePriceModal = withFunctionCall(BasePriceModal);

type BasePriceSelectProps = {
  value: BasePrice; // 当前选中的基准价
  onChange: (value: BasePrice) => void; // 基准价变更回调
  view?: boolean; // 是否为查看模式
  viewCurrencyType?: string; // 目标货币类型
  /** 查询基准价列表的请求函数，调用方负责绑定参数（如 demand_id、cooperate_account_id 等） */
  queryRequest?: () => Promise<{ data: BasePriceConfigDto[] }>;
};

/**
 * 基准价选择器组件
 * @description 用于选择或查看基准价的主组件，支持：
 * 1. 显示当前选中的基准价信息
 * 2. 点击编辑按钮打开基准价选择弹窗
 * 3. 点击清除按钮清空选中的基准价
 * 4. 查看模式下显示查看链接
 */
export default function BasePriceSelect(props: BasePriceSelectProps) {
  const {
    value,
    onChange,
    view = false,
    viewCurrencyType,
    queryRequest,
  } = props;

  /**
   * 基准价变更处理
   * @description 包装onChange回调，保持引用稳定
   */
  const onChangeTemp = useMemoizedFn((value: BasePrice) => {
    onChange?.(value);
  });

  /**
   * 打开基准价编辑弹窗
   * @description 打开基准价选择弹窗，传入当前项的查询参数和选中值
   */
  const editBasePrice = useMemoizedFn(() => {
    openBasePriceModal.show({
      value,
      onChange: onChangeTemp,
      view,
      viewCurrencyType,
      title: view ? '参考价' : '基准价',
      queryRequest,
    });
  });

  /** 左侧文案区域（编辑态和只读态共用） */
  const renderTextContent = () => (
    <>
      {/* 第一行：来源名称 */}
      <div className="flex justify-start items-center gap-2 w-full self-stretch shrink-0">
        {value?.source_name && (
          <div
            className="font-[600] text-color-1 flex-1 truncate"
            title={value?.source_name}
          >
            {value?.source_name || '--'}
          </div>
        )}
        {!value?.source_name && (
          <div className="text-sm text-color-1 flex-1">选择基准价</div>
        )}
        {/* 查看模式：查看详情链接保留在第一行右侧 */}
        {view && (
          <div className="flex justify-start items-center gap-1 flex-shrink-0">
            <Button
              type="text-neutral"
              suffixIcon={<ChevronRight />}
              onClick={editBasePrice}
            >
              参考价
            </Button>
          </div>
        )}
      </div>
      {/* 第二行：小类名称 + 价格 */}
      {(value?.base_price !== undefined || value?.base_price_name) && (
        <div className="flex justify-start items-center w-full overflow-hidden">
          {value?.base_price_name && (
            <>
              <div
                className="text-xs font-normal text-color-1 truncate overflow-hidden min-w-0 flex-basis-0 flex-shrink-1 flex-grow-0"
                title={value?.base_price_name}
              >
                {value?.base_price_name}
              </div>
              <div className="text-xs font-normal text-color-1 flex-shrink-0">
                ：
              </div>
            </>
          )}
          {value?.base_price !== undefined && (
            <div className="text-xs font-normal text-color-1 items-center flex-shrink-0">
              <CurrencyType
                wrapperProps={{
                  className: cx('base-price'),
                }}
                view={true}
                viewCurrencyType={viewCurrencyType as any}
                value={{
                  value: value?.base_price,
                  currency: value?.base_price_currency,
                }}
                currencyColor="black"
                showAmountOrder={false}
              />
            </div>
          )}
        </div>
      )}
    </>
  );

  return (
    <div
      className={cx(
        'flex justify-start items-center gap-3 p-2 rounded-md w-full',
        'base-price-select-wrapper',
        {
          'is-custom-price': value?.source_type === 'CUSTOM_PRICE',
        }
      )}
    >
      {!view ? (
        /* 编辑模式：左右布局，右侧按钮垂直居中 */
        <div className="flex items-center gap-2 w-full">
          <div
            className={cx([
              {
                'is-custom-price': value?.source_type === 'CUSTOM_PRICE',
              },
              'flex flex-col items-start gap-0 flex-1 min-w-0',
            ])}
          >
            {renderTextContent()}
          </div>
          <div className="flex flex-row items-center justify-center gap-1 flex-shrink-0">
            <Button
              type="text-subtle"
              icon={<Edit />}
              onClick={editBasePrice}
              size="xSmall"
            />
            {value?.source_type && (
              <Button
                type="text-subtle"
                icon={<Close />}
                onClick={() => onChangeTemp?.(undefined)}
                size="xSmall"
              />
            )}
          </div>
        </div>
      ) : (
        /* 只读模式：保持原有布局不变 */
        <div
          className={cx([
            {
              'is-custom-price': value?.source_type === 'CUSTOM_PRICE',
            },
            'flex flex-col items-start gap-0 w-full',
          ])}
        >
          {renderTextContent()}
        </div>
      )}
    </div>
  );
}
